import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, Typography } from '@mui/material';
import { usePurchase } from '../hooks/usePurchase';
import { ProductItem } from './ProductItem';
export const ProductList = () => {
    const { products, loading, error } = usePurchase();
    return (_jsx(Box, Object.assign({ sx: { padding: 2 } }, { children: loading ? (_jsxs(Box, Object.assign({ sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
            } }, { children: [_jsx(CircularProgress, {}), _jsx(Typography, Object.assign({ variant: "body1", sx: { marginLeft: 2 } }, { children: "Loading products..." }))] }))) : error ? (_jsx(Typography, Object.assign({ color: "error", align: "center" }, { children: `Error: ${error}` }))) : products && products.length > 0 ? (_jsx(Box, { children: products.map((product) => (_jsx(ProductItem, { product: product }, product.id))) })) : (_jsx(Typography, Object.assign({ align: "center", variant: "body1" }, { children: "No items available at the moment. Please check back later." }))) })));
};
